export const moduleId = 'redSaleReceiptManage';

export const state = {
    detailsDisplay: false,
    lists: {},//orglist
    dialogzt: false,//账套显示隐藏
    flag: false,//是否可编辑
    orgId: '',
    isShow: true,
    id: '',
    isDeapproval: false,
    isRouter: false,
    routeSource: false,
    isAdd: true,
    abId: '',
    orderNo: '',//发货/发票单号
}
export const mutations = {
    setRedSalePtIsAdd(state, flag) {
        state.isAdd = flag
    },
    //反审批
    setRedSalePtIsDeapproval(state, data) {
        state.isDeapproval = data
    },
    setRedSalePtRouteSource(state, data) {
        state.routeSource = data
    },
    setRedSalePtDetailsDisplay(state, data) {
        state.detailsDisplay = data
    },
    setRedSalePtDialogzt(state, data) {
        state.dialogzt = data
    },
    setRedSalePtOrgList(state, data) {
        state.lists = data
    },
    setRedSalePtFalg(state, data) {
        state.flag = data
    },
    setRedSalePtIsRouter(state, data) {
        state.isRouter = data
    },
    setRedSalePtOrderNo(state, data) {
        state.orderNo = data
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/billing-center/red-sale-receipt-manage/index.js